"use client"

import { AlertTriangle } from "lucide-react"
import { Button } from "../../components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog"

interface DeleteConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  beneficiaryName: string
}

export function DeleteConfirmationDialog({
  open,
  onOpenChange,
  onConfirm,
  beneficiaryName,
}: DeleteConfirmationDialogProps) {
  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <AlertTriangle className="h-6 w-6 text-destructive" />
          </div>
          <DialogTitle className="text-center text-xl">Eliminar Beneficiario</DialogTitle>
          <DialogDescription className="text-center">
            ¿Está seguro que desea eliminar al beneficiario{" "}
            <span className="font-semibold text-foreground">{beneficiaryName}</span>?
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-lg bg-muted p-4">
          <p className="text-center text-sm text-muted-foreground">
            Esta acción no se puede deshacer. El beneficiario será eliminado de la póliza y deberá agregarlo nuevamente
            si lo necesita.
          </p>
        </div>
        <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-center">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="w-full sm:w-auto">
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            className="w-full bg-destructive hover:bg-destructive/90 sm:w-auto"
          >
            Sí, Eliminar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
